module.exports = __webpack_public_path__ + "img/entrance.adbb9831.png";